<template>
  <div>
    <el-dialog
      title="导入记录"
      :visible.sync="dialogVisible"
      width="1000px"
      :before-close="close"
    >
      <div class="search_box">
        <el-form ref="form" :model="queryParams" label-width="100px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="文件名称">
                <el-input
                  v-model="queryParams.zipName"
                  size="mini"
                  placeholder="请输入文件名称"
                ></el-input> </el-form-item
            ></el-col>
            <el-col :span="10">
              <el-form-item label="文件上传结果">
                <itemSelect
                  v-model="queryParams.status"
                  :list="statusMap"
                  @onChange="onExecuteStatusChange"
                  class="itemSelect"
                /> </el-form-item
            ></el-col>
            <el-col :span="6">
              <div class="button-box">
                <el-button type="danger" @click="onSearch" size="mini"
                  >查 询</el-button
                >
                <el-button @click="onReset" size="mini" type="danger"
                  >重 置</el-button
                >
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="table-box">
        <el-table
          :data="tableData"
          style="padding: 0 24px"
          size="mini"
          :header-row-style="{ background: '#F8F8F8' }"
          :header-cell-style="{ background: '#F8F8F8' }"
        >
          <el-table-column prop="index" label="序号" width="60">
          </el-table-column>
          <el-table-column
            prop="zipName"
            label="文件名称"
            show-overflow-tooltip
            width="140"
          >
          </el-table-column>
          <el-table-column prop="createTime" label="上传时间" width="140">
          </el-table-column>
          <el-table-column prop="status" label="文件上传结果" width="100">
            <template slot-scope="scope">
              <div>
                <div>{{ statusMaps[scope.row.status] }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="succAmt" label="导入结果" width="140">
            <template slot-scope="scope">
              <div>
                成功{{ scope.row.succAmt }}件；失败{{ scope.row.failAmt }}件；
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="导入备注" show-overflow-tooltip>
          </el-table-column>
        </el-table>
      </div>

      <pagination
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="paginationChange"
        :page-sizes="[10, 100, 500]"
        size="mini"
      />
    </el-dialog>
  </div>
</template>

<script>
import itemSelect from "../../../components/itemSelect/index.vue";
import pagination from "@/components/components/pagination/index.vue";
import BaseApi from "@lib/baseApi.js";
export default {
  name: "",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    itemSelect,
    pagination,
  },

  data() {
    return {
      queryParams: {
        zipName: "",
        status: "",
        pageNumber: 1,
        pageSize: 10,
      },
      // TODO-未开始 PROC-进行中 FAIL-处理失败 SUCC-处理成功
      statusMap: { SUCC: "成功", FAIL: "失败" },
      statusMaps: {
        SUCC: "成功",
        FAIL: "失败",
        TODO: "未开始",
        PROC: "进行中",
      },
      tableData: [],
      total: 0,
    };
  },

  created() {
    this.getList();
  },

  methods: {
    getList() {
      this.$store.commit("showLoading", true);
      BaseApi.createRpcToken("/import/uploadRecordQuery", {
        ...this.queryParams,
      }).then(
        (data) => {
          this.$store.commit("showLoading", false);
          if (data.code == 200) {
            let list = data.datas.uploadRecord.list;
            list.forEach((item, index) => {
              item.index = index + 1;
              if (item.bizData) {
                item.bizData = JSON.parse(item.bizData);
              }
            });
            this.tableData = list;
            this.total = data.datas.uploadRecord.totalRow;
          } else {
            this.$message.error(data.message);
          }
        },
        (err) => {
          this.$store.commit("showLoading", false);
        }
      );
    },

    paginationChange(data) {
      this.queryParams.pageNumber = data.page;
      this.queryParams.pageSize = data.limit;
      this.getList();
    },

    // 查询
    onSearch() {
      this.getList();
    },
    // 重置
    onReset() {
      this.queryParams.status = "";
      this.queryParams.zipName = "";
      this.getList();
    },

    close() {
      this.$emit("close");
    },
    onExecuteStatusChange() {
      this.getList();
    },
    handleQuery() {},
    resetQuery() {},
  },
};
</script>

<style scoped lang='scss'>
::v-deep {
  .el-button--danger {
    color: #fff;
    background-color: #db1c1b;
    border-color: #db1c1b;
    font-size: 12px;
  }
  .el-button--danger.is-disabled,
  .el-button--danger.is-disabled:active,
  .el-button--danger.is-disabled:focus,
  .el-button--danger.is-disabled:hover {
    color: #fff;
    background-color: #fab6b6;
    border-color: #fab6b6;
  }
  .el-dialog__header {
    display: block;
  }
  .el-dialog {
    width: 100%;
  }
}

.itemSelect {
  height: 40px;
}

.button-box {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 24px;
}

.el-table::before {
  display: none;
}

.pagination-container {
  padding: 16px;
}

.table-box {
  min-height: 300px;
  max-height: 500px;
  overflow: auto;
}
</style>

<style>
/* 全局样式 */
.el-tooltip__popper.is-dark {
  max-width: 500px;
}
</style>
